import { createSlice } from '@reduxjs/toolkit'
import { initialState, generateTempUUID, initialPageData } from './initialState'
import { studioReducers } from './reducers'
import { GridItemData } from 'Vendor/Utils/StudioTypes'
import { fetchCreation, saveCreation } from './thunk'

const studioSlice = createSlice({
    name: 'studio',
    initialState,
    reducers: studioReducers,
    extraReducers: (builder) => {
        builder.addCase(fetchCreation.fulfilled, (state, action) => {
            state.status = 'succeeded'
            state.creationId = action.payload.id

            state.pages = {}
            state.pageIds = []

            const newPageId = generateTempUUID()
            const newPage = JSON.parse(JSON.stringify(initialPageData))

            action.payload.items.forEach((item: GridItemData) => {
                const assetId = generateTempUUID()
                const instanceId = item.id

                newPage.assets[assetId] = {
                    id: assetId,
                    type: item.type,
                    content: item.content,
                }

                newPage.layouts.desktop.items[instanceId] = {
                    id: instanceId,
                    assetId,
                    position: item.position,
                    size: item.size,
                    styles: { ...item.styles },
                    zIndex: item.zIndex,
                }
                newPage.layouts.desktop.itemIds.push(instanceId)

                newPage.layouts.mobile.items[instanceId] = {
                    id: instanceId,
                    assetId,
                    position: item.mobilePosition || item.position,
                    size: item.mobileSize || item.size,
                    styles: { ...item.styles },
                    zIndex: item.zIndex,
                }
                newPage.layouts.mobile.itemIds.push(instanceId)
            })

            state.pages[newPageId] = newPage
            state.pageIds.push(newPageId)

            state.activePageId = newPageId
        })
        builder
            .addCase(saveCreation.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(saveCreation.fulfilled, (state) => {
                state.status = 'succeeded'
            })
            .addCase(saveCreation.rejected, (state, action) => {
                state.status = 'failed'
                state.error = action.error.message || 'Failed to save creation'
            })
    },
})

export const {
    itemAdded,
    updateItem,
    itemMoved,
    itemResized,
    itemDeleted,
    itemSelected,
    itemDeselected,
    responsiveModeToggled,
    zoomIn,
    zoomOut,
    zoomTo,
    bringForward,
    sendBackward,
    itemDuplicated,
    itemGroupDuplicated,
    itemRotated,
    collectionItemsSelected,
    gridVisibilityToggled,
    setCreationData,
    pageAdded,
    pageSwitched,
    pageDeleted,
} = studioSlice.actions

export default studioSlice.reducer
